import { Components, Theme } from "@mui/material";

// TODO: refactor Filled and Outlined input styles

export const MuiFilledInput: Components<
  Omit<Theme, "MuiFilledInput">
>["MuiFilledInput"] = {
  styleOverrides: {
    input: ({ ownerState: { size } }) => ({
      height: size === "small" ? 32 : 52,
      padding: "2px 16px 2px",
    }),
    root: ({ theme: { palette } }) => ({
      background: "#FFFFFF",
      borderRadius: 12,
      borderWidth: 2,
      borderStyle: "solid",
      borderColor: "#E9E9E9",
      fontWeight: 400,
      fontSize: "14px",
      lineHeight: "14px",
      "& .MuiInputAdornment-filled": {
        // TODO: solve important
        margin: "0px !important",
        padding: 0,
      },
      "&:hover": {
        borderColor: palette.custom.purple[200],
        background: "#FFFFFF",
      },
      "&.Mui-focused": {
        borderColor: palette.custom.purple[200],
        background: "#FFFFFF",
      },
      "&.Mui-error": {
        borderColor: palette.custom.red[700],
      },
      "&:hover:before": {
        display: "none",
      },
      "&.Mui-disabled": {
        "&::before": {
          border: "none",
        },
      },
      "&::before": {
        border: "none",
      },
      "&::after": {
        border: "none",
        display: "none",
      },
    }),
  },
};
